import "./style.sass";

export const ManagementTitleCard = ({
  name, title, image, bio
}) => {
  const [firstName, lastName] = name.split(" ");
  return (
    <div className="management-title-card__wrapper">
      <div className="management-title-card">
        <div className="management-title-card__container">
          <div className="management-title-card__info">
            <h3>
              {firstName}
              <br />
              {lastName}
            </h3>
            <p>{title}</p>
          </div>
          {image && (
            <div className="management-title-card__image">
              <img src={image} alt={name} />
            </div>
          )}
        </div>
      </div>
      <div className="management-person-details-container">
        <div className="management-person-details-container__content" dangerouslySetInnerHTML={{ __html: bio }} />
      </div>
    </div>
  )
}